<template>
  <el-dialog
    :title="$t(`manage.labelInfo`)" :visible.sync="infoDialogVisible" :before-close="cancel" :close-on-click-modal="false" width="670px">
    <div class="require-content" :style="{'max-height': height - 150 + 'px'}">
      <h3>{{$t(`manage.supplierCall`)}}</h3>
      <div class="content-tip">{{$t(`manage.tipReason`)}}</div>
      <ul>
        <li>{{$t(`manage.minPageLabel`)}}</li>
        <li>{{$t(`manage.labelType`)}}</li>
        <li>{{$t(`manage.labelClear`)}}</li>
        <li>{{$t(`manage.otherReq`)}}</li>
        <div class="other-require">{{$t(`manage.labeledPosition`)}}</div>
        <div class="image-wrap">
          <img src="@/assets/images/head/require01.jpg" alt="">
          <img src="@/assets/images/head/require02.jpg" alt="">
        </div>
        <div class="other-require">{{$t(`manage.labelOrigin`)}}</div>
        <div class="other-require">{{$t(`manage.relationInOut1`)}}<span>020</span>{{$t(`manage.relationInOut2`)}}<span>020</span>{{$t(`manage.relationInOut3`)}}<span>020</span>{{$t(`manage.relationInOut4`)}}</div>
      </ul>
      <div class="noun-explanation">{{$t(`manage.nounExplanation`)}}</div>
      <ul>
        <li>{{$t(`manage.singleBox`)}}</li>
        <li>{{$t(`manage.inOutBox`)}}</li>
      </ul>
      <div class="content-tip" style="font-weight: bold;">{{$t(`manage.annotation`)}}</div>
      <div class="content-tip" style="padding-top: 14px;">{{$t(`manage.concat`)}}</div>
      <div class="tip-end">{{$t(`manage.time`)}}</div>
    </div>
    <div>
      <el-button class="confirm-btn" type="primary" @click="infoDialogVisible = false">
        {{$t(`button.confirm`)}}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  props: {
    fathInfoV: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cancel () {
      this.infoDialogVisible = false
    }
  },
  computed: {
    ...mapGetters(['height']),
    infoDialogVisible: {
      get () {
        return this.fathInfoV
      },
      set (val) {
        this.$emit('getInfoVisible', val)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.require-content {
  padding-bottom: 40px;
  text-align: left;
  overflow-y: auto;
  h3 {
    line-height: 30px;
  }
  .content-tip {
    text-indent: 20px;
    line-height: 26px;
  }
  .image-wrap {
    text-align: center;
    height: 220px;
    img {
      display: inline-block;
      width: 243px;
      height: 220px;
    }
  }
  li {
    padding-left: 20px;
  }
  .other-require {
    padding-left: 30px;
    span {
      color: #F56C6C;
      font-weight: bold;
    }
  }
  .noun-explanation {
    color: #8fc41e;
  }
  .tip-end {
    text-align: right;
  }
  li, .other-require, .content-tip, .noun-explanation, .tip-end {
    line-height: 26px;
    word-break: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Auth/LabelInfo.vue